import { render, staticRenderFns } from "./InvoiceUgd.vue?vue&type=template&id=9f0008fa&"
import script from "./InvoiceUgd.vue?vue&type=script&lang=js&"
export * from "./InvoiceUgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports